// Goal colours: stored as a hex string or, on old goals, a legacy name.

// Legacy name → canonical hex (bright stop of original gradient)
const LEGACY_COLOR_TO_HEX = {
  purple: "#5B50D9",
  teal:   "#2A9A78",
  amber:  "#E8853A",
  blue:   "#3B75D9",
  rose:   "#E8556A",
  green:  "#3DAA6A",
};

// Resolve legacy name or hex → canonical hex string
export const resolveColorHex = (color) => {
  if (!color) return "#5B50D9";
  if (color.startsWith("#")) return color;
  return LEGACY_COLOR_TO_HEX[color] || "#5B50D9";
};

// Darken a hex color by a given fraction (0–1)
const darkenHex = (hex, amount = 0.28) => {
  const h = hex.replace("#", "");
  const r = Math.round(parseInt(h.slice(0, 2), 16) * (1 - amount));
  const g = Math.round(parseInt(h.slice(2, 4), 16) * (1 - amount));
  const b = Math.round(parseInt(h.slice(4, 6), 16) * (1 - amount));
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

// Generate a vivid gradient from any hex color — replaces static GOAL_CARD_BG map
export const goalCardBg = (color) => {
  const hex = resolveColorHex(color);
  return `linear-gradient(135deg, ${darkenHex(hex)}, ${hex})`;
};

// Resolve goal color to theme-aware palette tokens — accepts name or hex
export const goalColorTokens = (color) => {
  const hex = resolveColorHex(color);
  const alpha = (h, a) => h + Math.round(a * 255).toString(16).padStart(2, "0");
  return {
    main:  hex,
    light: alpha(hex, 0.55),
    bg:    alpha(hex, 0.12),
  };
};
